const LiveNotificationsUrl = `${import.meta.env.VITE_WS_URL}${
  import.meta.env.VITE_ENVIRONMENT === 'local' ? '/sockets/ws/notifications' : '/ws/notifications'
}`;

export default LiveNotificationsUrl;
